import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import queries from './queries';

const getPeople = async (searchString) => {
  const data = await request.get(
    '/RentPlace/worker',
    { searchString },
    'При загрузке сотрудников произошла ошибка',
    []
  );
  return data.sort((a, b) => a.orderNum - b.orderNum);
};

const usePeople = (search) =>
  useQuery([queries.people, search], () => getPeople(search), {
    placeholderData: [],
  });

export default usePeople;
